import { createReducer } from "redux-act";
import * as actions from "#app/store/actions/interface";
import { CurrencyConstants } from "finhelper";
import { handleSetPortfolio } from "#app/store/actions/interface";

let state = {
    title: "",
    loader: false,
    clients: [],
    client: null,
    clientsLoading: true,
    currency: null,
    currencyLoading: true,
    currencies: [],
    accounts: [],
    accountLoading: true,
    courses: [],
    coursesLoading: true,
    contacts: [],
    contactsLoading: true,
    applications: [],
    portfolios: localStorage.getItem("portfolios")
        ? JSON.parse(localStorage.getItem("portfolios"))
        : [],
    selectedPortfolio: localStorage.getItem("selectedPortfolio")
        ? JSON.parse(localStorage.getItem("selectedPortfolio"))
        : null,
    applicationsLoading: true,
    sidebarOpen: localStorage.getItem("sidebar")
        ? JSON.parse(localStorage.getItem("sidebar"))
        : true,

    groupTypes: [],
    groupTypesLoading: true,
    classTypes: [],
    classTypesLoading: true,
    investTypes: [],
    investTypesLoading: true,
    propertyTypes: [],
    propertyTypesLoading: true,
    incomeTypes: [],
    incomeTypesLoading: true,
    spendTypes: [],
    spendTypesLoading: true,
    incomeTags: [],
    spendTags: [],
    investTags: [],
    tags: [],
    tagsLoading: true,
    incomeSubcategories: [],
    spendSubcategories: [],
    subcategoriesLoading: true,

    callToContact: null,
};

const handleTitle = (state, title) => {
    document.title = title;
    return {
        ...state,
        title: title,
    };
};

const handleLoader = (state, bool) => {
    return {
        ...state,
        loader: bool,
    };
};

const handleClient = (state, client) => {
    localStorage.setItem("client", JSON.stringify(client));

    return {
        ...state,
        client: client,
        clientsLoading: false,
    };
};

const handleCurrency = (state, currency) => {
    localStorage.setItem("currency", JSON.stringify(currency));

    return {
        ...state,
        currency: currency,
        currencyLoading: false,
    };
};

const handleContacts = (state, { data }) => {
    return {
        ...state,
        contacts: data,
        contactsLoading: false,
    };
};

const handleContactById = (state, { id, data }) => {
    const contactExists = state.contacts.some((item) => item.id === id);

    const updatedContacts = contactExists
        ? data
            ? state.contacts.map((contactItem) =>
                  contactItem.id === id ? { ...contactItem, ...data } : contactItem
              )
            : state.contacts.filter((contactItem) => contactItem.id !== id)
        : data
          ? [...state.contacts, { id, ...data }]
          : state.contacts;
    return { ...state, contacts: updatedContacts, contactsLoading: false };
};

const handleApplications = (state, response) => {
    return {
        ...state,
        applications: response.data,
        applicationsLoading: false,
    };
};

const handleApplicationCreate = (state, { id, data }) => {
    const applicationExists = state.applications.some((item) => item.id === id);

    const updatedApplications = applicationExists
        ? data
            ? state.applications.map((applicationItem) =>
                  applicationItem.id === id ? { ...applicationItem, ...data } : applicationItem
              )
            : state.applications.filter((applicationItem) => applicationItem.id !== id)
        : data
          ? [...state.applications, { id, ...data }]
          : state.applications;
    return { ...state, applications: updatedApplications, applicationsLoading: false };
};

const handleClients = (state, response) => {
    return {
        ...state,
        clients: response.data,
        clientsLoading: false,
    };
};

const updateClientInStore = (state, updatedClient) => {
    const clients = state.clients || [];
    const clientIndex = clients.findIndex((client) => client.id === updatedClient.id);

    if (clientIndex !== -1) {
        // Обновляем существующего клиента
        const updatedClients = [...clients];
        updatedClients[clientIndex] = { ...updatedClients[clientIndex], ...updatedClient };
        return {
            ...state,
            clients: updatedClients,
        };
    } else {
        // Если клиента нет в списке, добавляем его
        return {
            ...state,
            clients: [...clients, updatedClient],
        };
    }
};

const syncClientsFromAPI = (state, apiClients) => {
    // Синхронизируем клиентов из API с текущим состоянием
    const currentClients = state.clients || [];
    const apiClientsMap = new Map(apiClients.map((client) => [client.id, client]));

    // Обновляем существующих клиентов и добавляем новых
    const syncedClients = currentClients.map((client) => {
        const apiClient = apiClientsMap.get(client.id);
        return apiClient ? { ...client, ...apiClient } : client;
    });

    // Добавляем клиентов, которых нет в текущем списке
    const newClients = apiClients.filter(
        (apiClient) => !currentClients.some((client) => client.id === apiClient.id)
    );

    return {
        ...state,
        clients: [...syncedClients, ...newClients],
        clientsLoading: false,
    };
};

const handleClearClient = (state, client) => {
    localStorage.removeItem("client");

    return {
        ...state,
        client: null,
    };
};

const handleCurrencies = (state, data) => {
    let currency = localStorage.getItem("currency")
        ? JSON.parse(localStorage.getItem("currency"))
        : data[0]
          ? data[0]
          : null;

    CurrencyConstants.currencies = data;

    return {
        ...state,
        currency: currency,
        currencyLoading: currency ? false : true,
        currencies: data,
    };
};

const handleLogoutInterface = (state) => {
    return {
        title: "",
        loader: false,
        clients: [],
        client: null,
        clientsLoading: true,
        currency: null,
        currencyLoading: true,
        currencies: [],
        accounts: [],
        accountLoading: true,
        courses: [],
        coursesLoading: true,
        contacts: [],
        contactsLoading: true,
        applications: [],
        portfolios: localStorage.getItem("portfolios")
            ? JSON.parse(localStorage.getItem("portfolios"))
            : [],
        selectedPortfolio: localStorage.getItem("selectedPortfolio")
            ? JSON.parse(localStorage.getItem("selectedPortfolio"))
            : null,
        applicationsLoading: true,
        sidebarOpen: localStorage.getItem("sidebar")
            ? JSON.parse(localStorage.getItem("sidebar"))
            : true,

        callToContact: null,
    };
};

// const handleUserAccounts = (state, response) => {
//   if(typeof response === 'object' && response.result === 'success')
//   {
//     return {
//       ...state,
//       accounts: response.data,
//       accountLoading: false
//     }
//   }else{
//     return state;
//   }
// }

const handleCourses = (state, data) => {
    CurrencyConstants.courses = data;

    return {
        ...state,
        courses: data,
        coursesLoading: false,
    };
};

const handleSpendTypes = (state, response) => {
    if (typeof response === "object" && response.result === "success") {
        return {
            ...state,
            spendTypes: response.data,
            spendTypesLoading: false,
        };
    } else {
        return state;
    }
};

const handleIncomeTypes = (state, response) => {
    if (typeof response === "object" && response.result === "success") {
        return {
            ...state,
            incomeTypes: response.data,
            incomeTypesLoading: false,
        };
    } else {
        return state;
    }
};

const handleSidebarToggle = (state) => {
    localStorage.setItem("sidebar", JSON.stringify(!state.sidebarOpen));

    return {
        ...state,
        sidebarOpen: !state.sidebarOpen,
    };
};

const handleSidebarOpen = (state) => {
    localStorage.setItem("sidebar", JSON.stringify(true));

    return {
        ...state,
        sidebarOpen: true,
    };
};

const handlePropertyTypes = (state, response) => {
    if (typeof response === "object" && response.result === "success") {
        return {
            ...state,
            propertyTypes: response.data,
            propertyTypesLoading: false,
        };
    } else {
        return state;
    }
};

const handleInvestTypes = (state, response) => {
    if (typeof response === "object" && response.result === "success") {
        return {
            ...state,
            investTypes: response.data,
            investTypesLoading: false,
        };
    } else {
        return state;
    }
};

const handleGroupTypes = (state, response) => {
    if (typeof response === "object" && response.result === "success") {
        return {
            ...state,
            groupTypes: response.data,
            groupTypesLoading: false,
        };
    } else {
        return state;
    }
};

const handleClassTypes = (state, response) => {
    if (typeof response === "object" && response.result === "success") {
        return {
            ...state,
            classTypes: response.data,
            classTypesLoading: false,
        };
    } else {
        return state;
    }
};

const handleStartCall = (state, contact) => {
    return {
        ...state,
        callToContact: contact,
    };
};

const handleStopCall = (state) => {
    return {
        ...state,
        callToContact: null,
    };
};

const portfolioSetHandler = (state, response) => {
    const { portfolios } = state;
    const updatedPortfolios = portfolios
        .reduce((accumulator, portfolio) => {
            if (portfolio.user_id === response.user_id) {
                accumulator.push({ ...portfolio, portfolio_date: response.date });
            } else {
                accumulator.push(portfolio);
            }
            return accumulator;
        }, [])
        .concat(
            portfolios.every((portfolioItem) => portfolioItem.user_id !== response.user_id)
                ? [{ user_id: response.user_id, portfolio_date: response.date }]
                : []
        );

    try {
        localStorage.setItem("portfolios", JSON.stringify(updatedPortfolios));
    } catch (error) {
        console.error("Ошибка при сохранении portfolios в localStorage:", error);
    }

    return {
        ...state,
        portfolios: updatedPortfolios,
    };
};

const portfolioGetHandler = (state, action) => {
    const user_id = action.payload;
    const portfolio = state.portfolios.find((item) => item.user_id === user_id);
    return {
        ...state,
        selectedPortfolio: portfolio || null,
    };
};

const applicationGetHandler = (state, action) => {
    const application_id = action.payload;
    const application = state.applications.find((item) => application.id === item.id);
    return {
        ...state,
        selectedApplication: application ?? null,
    };
};

const applicationSetHandler = (state, response) => {
    const updatedApplications = state.applications
        .map((app) => (app.id === response.id ? { ...app, ...response } : app))
        .filter(Boolean);

    if (!updatedApplications.some((app) => app.id === response.id)) {
        updatedApplications.push(response);
    }

    return {
        ...state,
        applications: [...updatedApplications],
    };
};

const updateApplicationInStore = (state, updatedApplication) => {
    const applications = state.applications || [];
    const applicationIndex = applications.findIndex(
        (application) => application.id === updatedApplication.id
    );

    if (applicationIndex !== -1) {
        // Обновляем существующую заявку
        const updatedApplications = [...applications];
        updatedApplications[applicationIndex] = {
            ...updatedApplications[applicationIndex],
            ...updatedApplication,
        };
        return {
            ...state,
            applications: updatedApplications,
        };
    } else {
        // Если заявки нет в списке, добавляем её
        return {
            ...state,
            applications: [...applications, updatedApplication],
        };
    }
};

const syncApplicationsFromAPI = (state, apiApplications) => {
    // Синхронизируем заявки из API с текущим состоянием
    const currentApplications = state.applications || [];
    const apiApplicationsMap = new Map(
        apiApplications.map((application) => [application.id, application])
    );

    // Обновляем существующие заявки и добавляем новые
    const syncedApplications = currentApplications.map((application) => {
        const apiApplication = apiApplicationsMap.get(application.id);
        return apiApplication ? { ...application, ...apiApplication } : application;
    });

    // Добавляем заявки, которых нет в текущем списке
    const newApplications = apiApplications.filter(
        (apiApplication) =>
            !currentApplications.some((application) => application.id === apiApplication.id)
    );

    return {
        ...state,
        applications: [...syncedApplications, ...newApplications],
        applicationsLoading: false,
    };
};

const reducer = createReducer(
    {
        [actions.handleTitle]: handleTitle,
        [actions.handleCurrency]: handleCurrency,
        [actions.handleClient]: handleClient,
        [actions.handleClients]: handleClients,
        [actions.handleCurrencies]: handleCurrencies,
        // [actions.handleUserAccounts]: handleUserAccounts,
        [actions.handleCourses]: handleCourses,
        [actions.handleClearClient]: handleClearClient,
        [actions.handleLoader]: handleLoader,
        [actions.handleSidebarToggle]: handleSidebarToggle,
        [actions.handleSidebarOpen]: handleSidebarOpen,
        [actions.handleSpendTypes]: handleSpendTypes,
        [actions.handleIncomeTypes]: handleIncomeTypes,
        [actions.handlePropertyTypes]: handlePropertyTypes,
        [actions.handleInvestTypes]: handleInvestTypes,
        [actions.handleGroupTypes]: handleGroupTypes,
        [actions.handleClassTypes]: handleClassTypes,
        [actions.handleContacts]: handleContacts,
        [actions.handleContactById]: handleContactById,
        [actions.handleApplications]: handleApplications,
        [actions.handleApplicationCreate]: handleApplicationCreate,
        [actions.handleStartCall]: handleStartCall,
        [actions.handleStopCall]: handleStopCall,
        [actions.handleLogoutInterface]: handleLogoutInterface,
        [actions.handleSetPortfolio]: portfolioSetHandler,
        [actions.handleGetPortfolioById]: portfolioGetHandler,
        [actions.handleGetApplicationById]: applicationGetHandler,
        [actions.handleSetApplicationById]: applicationSetHandler,
        [actions.updateClientInStore]: updateClientInStore,
        [actions.syncClientsFromAPI]: syncClientsFromAPI,
        [actions.updateApplicationInStore]: updateApplicationInStore,
        [actions.syncApplicationsFromAPI]: syncApplicationsFromAPI,
    },
    state
);

export default reducer;
